import MKBox from 'components/MKBox';
import PropTypes from 'prop-types';

const YoutubeVideos = ({ videoId }) => {
  const embedUrl = `https://www.youtube.com/embed/${videoId}`;
  return (
    <MKBox>
      <iframe
        title={videoId}
        src={embedUrl}
        width='100%'
        height='100%'
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
        allowFullScreen
        style={{ border: '0', fontSize: '10px', borderRadius: '3px' }}
      ></iframe>
    </MKBox>
  );
};
YoutubeVideos.propTypes = {
  videoId: PropTypes.string.isRequired,
};

export default YoutubeVideos;
